import urlConfig from "../../../adapters/infrastructures/urlConfig/Reports/reportsUrl";
import { getReportHeaders } from "../../../adapters/infrastructures/urlConfig/Reports/reportHeaders";
import { ConsolidatedMapper } from "../../../domains/mapper/Reports/FamilyTagging/ConsolidatedDetails";
import { MyFamiliesMapper } from "../../../domains/mapper/Reports/FamilyTagging/MyFamiliesMapper";
import { getIsInIFrame } from "@domains/utils/tokenParser";
class FamilyTaggingRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async getFamilyDetails() {
        var _a;
        const accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(urlConfig.familyDetails + "/v1/");
        url.searchParams.append("accountIds", accountCode);
        let details = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        });
        // let details: IFamilyDetailsMainParams = dummyFamilyMem;
        details.data = (_a = details === null || details === void 0 ? void 0 : details.data) !== null && _a !== void 0 ? _a : {};
        details.myAccCode = accountCode;
        return MyFamiliesMapper(details);
    }
    async getConsolidatedDetails(req) {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(urlConfig.consolidatedDetails);
        url.searchParams.append("accodes", req.accodes);
        const reportData = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        });
        const finalReportData = ConsolidatedMapper(reportData === null || reportData === void 0 ? void 0 : reportData.data);
        return finalReportData;
    }
}
export default FamilyTaggingRepository;
